import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/PageParts";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDateTime } from "@/lib/format";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/audit"); setRows(data); }
      finally { setLoading(false); }
    })();
  }, []);
  return (
    <>
      <PageHeader title="Audit log" subtitle="Every state change captured with actor, timestamp and diff." />
      <PageBody>
        <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
            <TableBody>
              {loading && <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-8">Loading…</TableCell></TableRow>}
              {!loading && rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-8">No audit events yet.</TableCell></TableRow>}
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="text-xs font-mono">{fmtDateTime(r.at)}</TableCell>
                  <TableCell className="text-xs">{r.actor_email || "system"}</TableCell>
                  <TableCell className="text-xs font-mono">{r.action}</TableCell>
                  <TableCell className="text-xs">{r.entity_type} <span className="text-slate-400">·</span> <span className="font-mono">{r.entity_id?.slice(0, 8)}…</span></TableCell>
                  <TableCell className="text-xs font-mono text-slate-500 max-w-md truncate">{JSON.stringify(r.changes || {})}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </PageBody>
    </>
  );
}
